import { createReducer, on } from '@ngrx/store';
import { clearAgent, getAgent, getAgentFail, getAgentSuccess } from '@asm/features/asm/store/agent.actions';
import { failStatus, initialStatus, loadingStatus, successStatus } from '@core/models/request-status.model';
import { AgentUser } from '@asm/features/asm/models/asm.model';

const initialState: AgentUser = {
  uid: '',
  email: '',
  firstName: '',
  lastName: '',
  isAuthenticated: false,
  type: 'agent',
  ...initialStatus,
};

export const agentReducer = createReducer(
  initialState,

  on(clearAgent, (): AgentUser => {
    return {
      ...initialState,
    };
  }),

  on(getAgent, (state: AgentUser): AgentUser => {
    return {
      ...state,
      ...loadingStatus,
    };
  }),

  on(getAgentSuccess, (_state: AgentUser, data: any): AgentUser => {
    return {
      ...data.agent,
      isAuthenticated: true,
      ...successStatus,
    };
  }),

  on(getAgentFail, (_state: AgentUser, data: any): AgentUser => {
    return {
      ...initialState,
      ...failStatus,
      message: data.errorMessage,
    };
  }),
);
